import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import appConstant from '../../constants';
import ah from '../../helpers/Axhelper';
import * as actions from "./actions";

let defLimit = 50;
let defSortColumn = 'created';
let defSortDirection = 'desc';

let urlAll = appConstant.baseUrl+"referrals/all/";
let urlDetails = appConstant.baseUrl+"referrals/details/";
let urlSearch = appConstant.baseUrl+"referrals/search/"; 
let urlStats = appConstant.baseUrl+"referrals/stats/"; 
let urlDelete = appConstant.baseUrl+"referrals/";
let urlInsert = appConstant.baseUrl+"referrals/";
let urlUpdate = appConstant.baseUrl+"referrals/";
let urlUsePoints = appConstant.baseUrl+"referrals/usepoints/";

const computeListUrl = (searchField, sortColumn, sortDirection, limit) => {
    let computedSort = sortColumn || defSortColumn;
    let computedDirection = sortDirection || defSortDirection;
    let computedLimit = limit || defLimit; 
    let computedSearchUrl = urlSearch.concat(encodeURIComponent(searchField)).concat(`?sortcol=${computedSort}&sortdir=${computedDirection}&limit=${computedLimit}`);
    let computedAllUrl = urlAll.concat(`?sortcol=${computedSort}&sortdir=${computedDirection}&limit=${computedLimit}`);

    if(!searchField || searchField.length===0) { 
        return computedAllUrl 
    } else { 
        return computedSearchUrl 
    }
}

function* getItems(actionObject) {
    let {searchField, sortColumn, sortDirection, limit} = actionObject.payload;
    let currentUrl = computeListUrl(searchField, sortColumn, sortDirection, limit);
    const response = yield call(ah.sendGetAsync,currentUrl);
    if(response.error){
        yield put(actions.referralsGetError(response.error));
    } else {
        yield put(actions.referralsGetSuccess(response.data,response.headers["x-total-count"]));
    }
}

function* statsLoad() {
    const response = yield call(ah.sendGetAsync,urlStats);
    if(response.error){
        yield put(actions.referralsStatsLoadError(response.error));
    } else {
        yield put(actions.referralsStatsLoadSuccess(response.data));
    }
}

/* eslint require-yield: 0 */  
function* setSearch(actionObject) {
    if(actionObject.payload.length>=3){
        getItems(actionObject);
    }
}

function* loadMore(actionObject) {
    let {searchField, sortColumn, sortDirection, limit} = actionObject.payload;
    let currentUrl = computeListUrl(searchField, sortColumn, sortDirection, limit);
    const response = yield call(ah.sendGetAsync,currentUrl);
    if(response.error){
        yield put(actions.referralsLoadMoreError(response.error));
    } else {
        yield put(actions.referralsLoadMoreSuccess(response.data,response.headers["x-total-count"]));
    }
}

function* deleteItem(actionObject) {
    let id = actionObject.payload;
    let currentUrl = urlDelete.concat(id);
    const response = yield call(ah.sendDeleteAsync,currentUrl);
    if(response.error){
        yield put(actions.referralsDeleteItemError(response.error));
    } else {
        yield put(actions.referralsDeleteItemSuccess(response.data));
    }
}

function* getDetails(actionObject) {
    let id = actionObject.payload;
    let currentUrl = urlDetails.concat(id);
    const response = yield call(ah.sendGetAsync,currentUrl);
    if(response.error){
        yield put(actions.referralsGetDetailsError(response.error));
    } else {
        yield put(actions.referralsGetDetailsSuccess(response.data));
    }
}

function* insert(actionObject) {
    let item = actionObject.payload;
    const response = yield call(ah.sendPostAsync,urlInsert,item);
    if(response.error){
        yield put(actions.referralsInsertError(response.error));
    } else {
        yield put(actions.referralsInsertSuccess(response.data));
    }
}

function* loadUpdate(actionObject) {
    let id = actionObject.payload;
    let currentUrl = urlDetails.concat(id);
    const response = yield call(ah.sendGetAsync,currentUrl);
    if(response.error){
        yield put(actions.referralsLoadUpdateError(response.error));
    } else {
        yield put(actions.referralsLoadUpdateSuccess(response.data));
    }
}

function* update(actionObject) {
    let id = actionObject.payload.id;
    let currentUrl = urlUpdate.concat(id);
    const response = yield call(ah.sendPutAsync,currentUrl, actionObject.payload.item);
    if(response.error){
        yield put(actions.referralsUpdateError(response.error));
    } else {
        yield put(actions.referralsUpdateSuccess(response.data));
    }
}

function* usePoints(actionObject) {
    let id = actionObject.payload.id;
    let currentUrl = urlUsePoints.concat(id);
    const response = yield call(ah.sendPutAsync,currentUrl, {productName: actionObject.payload.productName, points: actionObject.payload.points});
    if(response.error){
        yield put(actions.referralsUsePointsError(response.error));
    } else {
        yield put(actions.referralsUsePointsSuccess(response.data));
    }
}

export function* watchActions() {
    yield takeEvery('REFERRALS_GET', getItems);
    yield takeEvery('REFERRALS_SET_SEARCH_FIELD', setSearch);
    yield takeEvery('REFERRALS_LOAD_MORE', loadMore);
    yield takeEvery('REFERRALS_DELETE_ITEM', deleteItem);
    yield takeEvery('REFERRALS_GET_DETAILS', getDetails);
    yield takeEvery('REFERRALS_INSERT', insert);
    yield takeEvery('REFERRALS_LOAD_UPDATE', loadUpdate);
    yield takeEvery('REFERRALS_UPDATE', update);
    yield takeEvery('REFERRALS_STATS_LOAD', statsLoad);
    yield takeEvery('REFERRALS_USE_POINTS', usePoints);
}

export default function* rootSaga() {
    yield all([
        fork(watchActions)
    ]);
}